
// C O U N T D O W N  C L O C K

var countdown = setInterval(function(){ timer() }, 1000);
function timer() {
    var d = new Date();
    d.setMinutes(d.getMinutes());
    d.setHours(d.getHours() - 15);
    var h = 23 - d.getHours();
    var m = 59 - d.getMinutes();
    var s = 59 - d.getSeconds();
  
    if (h == 0){document.getElementById("hours").innerHTML = "";}
    else if (h == 1) {document.getElementById("hours").innerHTML = h + " hour ";}
    else {document.getElementById("hours").innerHTML = h + " hours, ";};  
  
    if (m == 0) {document.getElementById("minutes").innerHTML = "";}
    else if (m == 1) {document.getElementById("minutes").innerHTML = m + " minute";}
    else {document.getElementById("minutes").innerHTML = m + " minutes & ";};
  
    document.getElementById("seconds").innerHTML = s + " seconds ";
  
    if (m > 0) {$(".hello span").addClass("countdown");}
    else {$(".hello span").removeClass("countdown");
    };
}


// S W I P E R

function resizeSwiper() {
    $('.swiper-container').height($('.swiper-slide img').height())
}

var swiper;

var options = {}; 
options.preloadImages = false; // Disable preloading of all images
options.lazyLoading = true; // Enable lazy loading
options.slidesPerView = 1;
options.lazyLoadingInPrevNext = true;
options.lazyLoadingInPrevNextAmount  = 1;
options.loop = true;
options.pagination = '.swiper-pagination';
options.paginationClickable = true;
options.keyboardControl = true;
options.speed = 600;
options.initialSlide = 0;
    

(function(){
    enquire.register("screen and (min-width: 960px)", {
        match : function() {
         if(swiper) swiper.destroy(true, true);
         options.direction = "vertical";
         options.mousewheelControl = true;
         // options.grabCursor = true;
         swiper = new Swiper( '.swiper-container', options );
}  
    
  });

  enquire.register("screen and (max-width: 960px)", {
  
    match : function() {
          if(swiper) swiper.destroy(true, true);
                options.direction = "horizontal";
                options.mousewheelControl = false;
                options.nextButton = '.swiper-button-next';
                options.prevButton = '.swiper-button-prev';
            swiper = new Swiper( '.swiper-container', options );
        }    
    });



})();

// S L I D E  O U T  C A R T

$(function() {
    var toggle = $(".toggle"),
        overlay = $(".overlay"),
        cartSlide = $(".cart-slide");

    toggle.on("click", function() {
        cartSlide.toggleClass("cart-open");
        overlay.toggleClass("overlay-open");
    });
    overlay.on("click", function(){
        overlay.toggleClass("overlay-open");
        cartSlide.removeClass("cart-open");
    });  
});

// S L I D E  O U T  N A V

$(function() {
    var navToggle = $(".nav-toggle"),
        navOverlay = $(".nav-overlay"),
        navSlide = $(".nav-slide");
        navLink = $(".nav-slide a");
        navIcon = $(".fa-bars");

    navToggle.on("click", function() {
        navSlide.toggleClass("nav-open");
        navOverlay.toggleClass("nav-overlay-open");
        navIcon.toggleClass("fa-bars");
        navIcon.toggleClass("fa-times");
    });
    navOverlay.on("click", function(){
        navOverlay.toggleClass("nav-overlay-open");
        navSlide.removeClass("nav-open");
        navIcon.toggleClass("fa-bars");
        navIcon.toggleClass("fa-times");
    });  
    navLink.on("click", function(){
        navOverlay.toggleClass("nav-overlay-open");
        navSlide.removeClass("nav-open");
        navIcon.toggleClass("fa-bars");
        navIcon.toggleClass("fa-times");
    }); 
});

// U N V E I L . J S

$(function() {
  $(".picture img").unveil(200, function() {
    $(this).load(function() {
      this.style.opacity = 1;
    });
  });
});

$(function() {
  $(".swiper-slide img").unveil(20000, function() {
    $(this).load(function() {
      this.style.opacity = 1;
    });
  });
});


// A D D  T O   C A R T

function change(){
    document.getElementById("add").value="Adding...";
    setTimeout(function(){
        document.getElementById("add").value="Item Added";}, 1000)
    setTimeout(function(){
        document.getElementById("add").value="Add To Cart";}, 5000)
}


// S H I P P I N G  C A L C U L A T O R

$(document).ready(function () {
    $('.box').hide();
    $('#option1').show();
    $('#selectCountry').change(function () {
        $('.box').hide();
        $('#'+$(this).val()).show();
    });
});


// L O G I N  F O R M S

$(document).ready(function () {
    var     loginMain = $(".customer-login-main")
            login = $(".customer-login-form"),
            recover = $(".recover-password"),
            create = $(".create_customer"),
            guest = $(".guest-login");

    $(".forgot-password a").click(function() {
      login.toggle();
      guest.toggle();
      recover.fadeToggle("slow");
  });

  $(".recover-cancel a").click(function() {
    $(".guest-login, .recover-password").toggle();
    login.fadeToggle("slow");
  });

  $(".create-account").click(function() {
        $(".customer-login-main, .guest-login").toggle();
        create.fadeToggle("slow");
        $(".create-account").toggleClass("selected");
        $(".login-title").toggleClass("selected");
  });
    $(".login-title").click(function() {
        $(".guest-login").toggle();
        create.toggle();
        loginMain.fadeToggle("slow");
        $(".login-title").toggleClass("selected");
        $(".create-account").toggleClass("selected");
  });

  
});

